import { jsPDF } from 'jspdf';
 
import html2canvas from 'html2canvas';
import { sendEmailWithBrevo } from '../services/brevoEmailService';

// Sistem ekran görüntüsünü alma
export const captureSystemCard = async (elementId) => {
  const element = document.getElementById(elementId);
  if (!element) return null;
  
  const canvas = await html2canvas(element, { 
    scale: 2, // Daha yüksek kalite için
    useCORS: true,
    logging: false,
    backgroundColor: null
  });
  
  return canvas.toDataURL('image/png');
};

/**
 * Sistem için profesyonel PDF raporu oluşturma
 * @param {Object} system - Sistem verileri
 * @param {boolean} solarEnabled - Güneş enerjisi aktif mi
 * @param {Object} globalParams - Global parametreler
 */
export const generateSystemReport = async (system, solarEnabled, globalParams) => {
  // Geçici HTML tablo oluşturma
  const tempDiv = document.createElement('div');
  tempDiv.style.position = 'absolute';
  tempDiv.style.left = '-9999px';
  tempDiv.style.top = '-9999px';
  
  tempDiv.innerHTML = `
    <div style="font-family: Arial, sans-serif; padding: 20px; width: 800px;">
      <div style="background-color: #4338CA; color: white; padding: 20px; text-align: center;">
        <h1 style="margin: 0; font-size: 24px;">ISI POMPASI SİSTEM RAPORU</h1>
        <p style="margin-top: 5px;">Mext Isı Pompası Hesaplama Aracı</p>
      </div>
      
      <div style="margin-top: 20px;">
        <h2 style="color: #4338CA;">1. SİSTEM BİLGİLERİ</h2>
        <p>
          <strong>Sistem Adı:</strong> ${system.name}<br>
          <strong>Sistem Tipi:</strong> ${getSystemTypeName(system.type)}<br>
          <strong>Güneş Enerjisi Desteği:</strong> ${solarEnabled ? 'Aktif' : 'Pasif'}
        </p>
      </div>
      
      <div style="margin-top: 20px;">
        <h2 style="color: #4338CA;">2. SİSTEM PARAMETRELERİ</h2>
        <!-- Tablo stillerini düzeltme -->
        <table style="width: 100%; border-collapse: collapse; margin-top: 10px;">
          <thead>
            <tr style="background-color: #4F46E5; color: white;">
              <th style="padding: 12px; text-align: left; border: 1px solid #ddd; font-weight: bold;">Parametre</th>
              <th style="padding: 12px; text-align: right; border: 1px solid #ddd; font-weight: bold;">Değer</th>
              <th style="padding: 12px; text-align: left; border: 1px solid #ddd; font-weight: bold;">Birim</th>
            </tr>
          </thead>
          <tbody>
            <tr style="background-color: #f5f5f5;">
              <td style="padding: 10px; border: 1px solid #ddd; border-top: none;">Isıtma Kapasitesi</td>
              <td style="padding: 10px; text-align: right; border: 1px solid #ddd; border-top: none;">${formatValue(system.heatingCapacity)}</td>
              <td style="padding: 10px; border: 1px solid #ddd; border-top: none;">kW</td>
            </tr>
            <tr>
              <td style="padding: 10px; border: 1px solid #ddd; border-top: none;">Soğutma Kapasitesi</td>
              <td style="padding: 10px; text-align: right; border: 1px solid #ddd; border-top: none;">${formatValue(system.coolingCapacity)}</td>
              <td style="padding: 10px; border: 1px solid #ddd; border-top: none;">kW</td>
            </tr>
            <tr style="background-color: #f5f5f5;">
              <td style="padding: 10px; border: 1px solid #ddd; border-top: none;">Isıtma Sıcaklığı</td>
              <td style="padding: 10px; text-align: right; border: 1px solid #ddd; border-top: none;">${formatValue(system.heatingTemperature)}</td>
              <td style="padding: 10px; border: 1px solid #ddd; border-top: none;">°C</td>
            </tr>
            <tr>
              <td style="padding: 10px; border: 1px solid #ddd; border-top: none;">Soğutma Sıcaklığı</td>
              <td style="padding: 10px; text-align: right; border: 1px solid #ddd; border-top: none;">${formatValue(system.coolingTemperature)}</td>
              <td style="padding: 10px; border: 1px solid #ddd; border-top: none;">°C</td>
            </tr>
            <tr style="background-color: #f5f5f5;">
              <td style="padding: 10px; border: 1px solid #ddd; border-top: none;">Çalışma Saati</td>
              <td style="padding: 10px; text-align: right; border: 1px solid #ddd; border-top: none;">${formatValue(system.workingHours || globalParams.workingHours)}</td>
              <td style="padding: 10px; border: 1px solid #ddd; border-top: none;">saat/yıl</td>
            </tr>
          </tbody>
        </table>
      </div>
      
      ${system.results ? `
      <div style="margin-top: 20px;">
        <h2 style="color: #4338CA;">3. SİSTEM PERFORMANS SONUÇLARI</h2>
        <!-- Tablo stillerini düzeltme -->
        <table style="width: 100%; border-collapse: collapse; margin-top: 10px;">
          <thead>
            <tr style="background-color: #2E7D32; color: white;">
              <th style="padding: 12px; text-align: left; border: 1px solid #ddd; font-weight: bold;">Performans Göstergesi</th>
              <th style="padding: 12px; text-align: right; border: 1px solid #ddd; font-weight: bold;">Değer</th>
              <th style="padding: 12px; text-align: left; border: 1px solid #ddd; font-weight: bold;">Birim</th>
            </tr>
          </thead>
          <tbody>
            <tr style="background-color: #E8F5E9;">
              <td style="padding: 10px; border: 1px solid #ddd; border-top: none;">COP (Performans Katsayısı)</td>
              <td style="padding: 10px; text-align: right; border: 1px solid #ddd; border-top: none;">${formatValue(system.results.cop, 2)}</td>
              <td style="padding: 10px; border: 1px solid #ddd; border-top: none;">-</td>
            </tr>
            <tr>
              <td style="padding: 10px; border: 1px solid #ddd; border-top: none;">Enerji Tüketimi</td>
              <td style="padding: 10px; text-align: right; border: 1px solid #ddd; border-top: none;">${formatValue(system.results.energy, 1)}</td>
              <td style="padding: 10px; border: 1px solid #ddd; border-top: none;">MWh/yıl</td>
            </tr>
            <tr style="background-color: #E8F5E9;">
              <td style="padding: 10px; border: 1px solid #ddd; border-top: none;">Tasarruf</td>
              <td style="padding: 10px; text-align: right; border: 1px solid #ddd; border-top: none;">${formatValue(system.results.savings, 1)}</td>
              <td style="padding: 10px; border: 1px solid #ddd; border-top: none;">bin €/yıl</td>
            </tr>
            <tr>
              <td style="padding: 10px; border: 1px solid #ddd; border-top: none;">CO2 Emisyon Azaltımı</td>
              <td style="padding: 10px; text-align: right; border: 1px solid #ddd; border-top: none;">${formatValue(solarEnabled ? 0 : system.results.co2, 0)}</td>
              <td style="padding: 10px; border: 1px solid #ddd; border-top: none;">ton/yıl</td>
            </tr>
          </tbody>
        </table>
      </div>
      
      <div style="margin-top: 20px;">
        <h2 style="color: #4338CA;">4. ÇEVRESEL VE EKONOMİK ETKİ</h2>
        <p>
          Bu sistem, konvansiyonel ısıtma sistemlerine kıyasla:
        </p>
        <ul style="list-style-type: disc; padding-left: 20px; line-height: 1.5;">
          <li>Yıllık yaklaşık ${formatValue(system.results.savings, 1)} bin € finansal tasarruf sağlar</li>
          <li>Atmosfere salınan CO2 emisyonunu ${formatValue(solarEnabled ? 0 : system.results.co2, 0)} ton azaltır</li>
          <li>Toplam enerji verimliliğini %${Math.round((system.results.cop - 1) * 100)} artırır</li>
          ${solarEnabled ? '<li>Güneş enerjisi desteği ile sıfır karbon emisyonu sağlar</li>' : ''}
        </ul>
      </div>` : ''}
      
      <div style="margin-top: 20px;">
        <h2 style="color: #4338CA;">5. ÖNERİLER</h2>
        <p>Sistem performansını optimize etmek için:</p>
        <ul style="list-style-type: disc; padding-left: 20px; line-height: 1.5;">
          <li>Düzenli bakım ve kontroller yaptırın</li>
          <li>Yalıtım iyileştirmeleriyle sistem verimliliğini artırın</li>
          <li>Kullanım saatleri ve sıcaklık ayarlarını optimize edin</li>
          <li>Enerji tüketimini düzenli olarak takip edin</li>
        </ul>
      </div>
      
      <div style="margin-top: 40px; border-top: 1px solid #eee; padding-top: 10px; font-size: 10px; color: #666; text-align: center;">
        © ${new Date().getFullYear()} Mext Isı Pompası Hesaplama Aracı
      </div>
    </div>
  `;
  
  document.body.appendChild(tempDiv);
  
  try {
    // HTML'i canvas'a dönüştür - gereksiz loglama olmadan
    const canvas = await html2canvas(tempDiv, {
      scale: 1.5, // Daha yüksek kalite 
      useCORS: true,
      logging: false,
      backgroundColor: '#ffffff', // Beyaz arkaplan
      removeContainer: true // Daha temiz render
    });
    
    // Canvas'ı PDF'e dönüştür - kalite parametresi ekle
    const imgData = canvas.toDataURL('image/png', 0.95); // 0.95 kalite
    const pdf = new jsPDF('p', 'mm', 'a4');
    
    const pdfWidth = pdf.internal.pageSize.getWidth();
    const pdfHeight = pdf.internal.pageSize.getHeight();
    
    pdf.addImage(imgData, 'PNG', 0, 0, pdfWidth, pdfHeight);
    
    return pdf.output('blob');
  } finally {
    // Geçici elementi temizle
    document.body.removeChild(tempDiv);
  }
};

/**
 * Sistem tipine göre insan tarafından okunabilir isim dönüştürme
 */
function getSystemTypeName(type) {
  switch (type) {
    case 'chiller': return 'Chiller';
    case 'boiler': return 'Kazan';
    case 'heatRecovery': return 'Atık Isı';
    case 'coolingTower': return 'Soğutma Kulesi';
    default: return 'Genel Sistem';
  }
}

/**
 * Sayısal değerleri formatlar
 */
function formatValue(value, precision = 0) {
  if (value === undefined || value === null) return '-';
  
  if (precision === 0) return Math.round(value).toString();
  
  return Number(value).toFixed(precision);
}

// Email gönderme fonksiyonunu güncelle
export const sendReportByEmail = async (email, pdfBlob, systemName) => {
  try {
    // Brevo API kullanarak e-posta gönder
    // 'result' değişkeni hiç kullanılmıyor, sonucu doğrudan kullan
    await sendEmailWithBrevo(email, pdfBlob, systemName);
    
    return { success: true, message: 'Rapor başarıyla gönderildi!' };
  } catch (error) {
    console.error('E-posta gönderme hatası:', error);
    throw new Error('E-posta gönderilirken bir hata oluştu');
  }
};